import isValid from 'date-fns/isValid'
import parseISO from 'date-fns/parseISO'
import subSeconds from 'date-fns/subSeconds'
import isAfter from 'date-fns/isAfter'
import isEqual from 'date-fns/isEqual'
import { addEntry } from '../audit'

export enum DeadMansHandleStatus {
  VALID,
  WARN,
  KILL
}

/**
 * Determines whether the Dead Man's Handle modal should be shown or if the gig should be killed
 * @param gigTerminationTime An ISO string representing the gig termination time
 * @return String constant representing the status of the Dead Man's Handle
 */

const _WARNING_PERIOD = 120 // 2 minutes

export default function (gigTerminationTime: string): DeadMansHandleStatus {

  let isGigTerminationTimeValid = false

  try {

    isGigTerminationTimeValid = isValid(parseISO(gigTerminationTime))

  }
  catch (e) {}

  if (!isGigTerminationTimeValid) {

    addEntry('PresenterService', 'ShowDeadMansHandle', `Gig termination time isn't a valid date`)

  }

  const currentDatetime = new Date(Date.now())
  const killDatetime = parseISO(gigTerminationTime)
  const warnDatetime = subSeconds(killDatetime, _WARNING_PERIOD)
  const shouldKillGig: boolean = isAfter(currentDatetime, killDatetime)
  const shouldWarnGig: boolean = isEqual(currentDatetime, warnDatetime) || isAfter(currentDatetime, warnDatetime)

  if (shouldKillGig) return DeadMansHandleStatus.KILL
  return shouldWarnGig
    ? DeadMansHandleStatus.WARN
    : DeadMansHandleStatus.VALID

}
